import React, { useEffect, useState } from 'react';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { FramingBand } from './components/FramingBand';
import { ProblemSection } from './components/ProblemSection';
import { PlatformOverview } from './components/PlatformOverview';
import { OperatingModel } from './components/OperatingModel';
import { CapabilityDomains } from './components/CapabilityDomains';
import { HumanOpportunity } from './components/HumanOpportunity';
import { LifecycleArchitecture } from './components/LifecycleArchitecture';
import { Solutions } from './components/Solutions';
import { ProductEcosystem } from './components/ProductEcosystem';
import { GlobalArchitecture } from './components/GlobalArchitecture';
import { LeadershipReadiness } from './components/LeadershipReadiness';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { CJIPage } from './components/CJIPage';
import { NCJIPage } from './components/NCJIPage';
import { SolutionsPage } from './components/SolutionsPage';
import { AboutPage } from './components/AboutPage';
import { ResearchPage } from './components/ResearchPage';
import { PartnershipsPage } from './components/PartnershipsPage';
import { ContactPage } from './components/ContactPage';
import { PrivacyPolicyPage } from './components/PrivacyPolicyPage';
import { TermsOfServicePage } from './components/TermsOfServicePage';
import { GovernmentPage } from './components/GovernmentPage';
import { EducationPage } from './components/EducationPage';
import { EmployersPage } from './components/EmployersPage';
import { CivilSocietyPage } from './components/CivilSocietyPage';
import { LeadershipPage } from './components/LeadershipPage';
import { ReasoningQualityPage } from './components/ReasoningQualityPage';
import { ConsequentialThinkingPage } from './components/ConsequentialThinkingPage';
import { ManipulationResistancePage } from './components/ManipulationResistancePage';
import { EmotionalRegulationPage } from './components/EmotionalRegulationPage';
import { SocialCooperationPage } from './components/SocialCooperationPage';
import { SelfDirectionPage } from './components/SelfDirectionPage';
import { LeadershipResponsibilityPage } from './components/LeadershipResponsibilityPage';
import { IndividualLevelPage } from './components/IndividualLevelPage';
import { OrganizationalLevelPage } from './components/OrganizationalLevelPage';
import { MunicipalScalePage } from './components/MunicipalScalePage';
import { NationalScalePage } from './components/NationalScalePage';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1) || 'home';
      setCurrentPage(hash);
      window.scrollTo(0, 0);
    };
    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  const renderPage = () => {
    switch (currentPage) {
      case 'cji':
        return <>
            <CJIPage data-id="element-0" data-mp="yfli9gjlida0" />
            <FinalCTA data-id="element-1" data-mp="yg3lwy8l7try" />
          </>;
      case 'ncji':
        return <>
            <NCJIPage data-id="element-2" data-mp="13e54zj60jt3f" />
            <FinalCTA data-id="element-3" data-mp="13fpzj8sbvc1a" />
          </>;
      case 'solutions':
        return <>
            <SolutionsPage data-id="element-4" data-mp="1r5kcdqcnd0lj" />
            <FinalCTA data-id="element-5" data-mp="1r268ues8ylci" />
          </>;
      case 'about':
        return <>
            <AboutPage data-id="element-6" data-mp="1w2kg3um0xr9h" />
            <FinalCTA data-id="element-7" data-mp="1i3kt0re5tkff" />
          </>;
      case 'research':
        return <>
            <ResearchPage data-id="element-8" data-mp="1m5617zfr1aja" />
            <FinalCTA data-id="element-9" data-mp="1m4ehblvil18u" />
          </>;
      case 'partnerships':
        return <>
            <PartnershipsPage data-id="element-10" data-mp="6ncmyfzirqz0" />
            <FinalCTA data-id="element-11" data-mp="6n4b8rf4urpe" />
          </>;
      case 'contact':
        return <>
            <ContactPage data-id="element-12" data-mp="arc2av92cjqs" />
            <FinalCTA data-id="element-13" data-mp="qx5hw2u8iwcl" />
          </>;
      case 'privacy':
        return <PrivacyPolicyPage data-id="element-14" data-mp="qygmu5zf2a5a" />;
      case 'terms':
        return <TermsOfServicePage data-id="element-15" data-mp="m65i8ptqe06e" />;
      case 'government':
        return <>
            <GovernmentPage data-id="element-16" data-mp="h6szoh9w7f9m" />
            <FinalCTA data-id="element-17" data-mp="h842oevikizo" />
          </>;
      case 'education':
        return <>
            <EducationPage data-id="element-18" data-mp="c9kh4fku197u" />
            <FinalCTA data-id="element-19" data-mp="c66ed689axzv" />
          </>;
      case 'employers':
        return <>
            <EmployersPage data-id="element-20" data-mp="19tnhf6fbs0je" />
            <FinalCTA data-id="element-21" data-mp="14wexb0am9mfi" />
          </>;
      case 'civil-society':
        return <>
            <CivilSocietyPage data-id="element-22" data-mp="zxal00seb8ky" />
            <FinalCTA data-id="element-23" data-mp="zw8zf2dr73oz" />
          </>;
      case 'leadership':
        return <>
            <LeadershipPage data-id="element-24" data-mp="vvp1hwlcvw1s" />
            <FinalCTA data-id="element-25" data-mp="vykzfkx7ekq8" />
          </>;
      case 'reasoning-quality':
        return <>
            <ReasoningQualityPage data-id="element-26" data-mp="3gmhacqeoi0em" />
            <FinalCTA data-id="element-27" data-mp="3glegc9m27huh" />
          </>;
      case 'consequential-thinking':
        return <>
            <ConsequentialThinkingPage data-id="element-28" data-mp="1w5zxud3squkx" />
            <FinalCTA data-id="element-29" data-mp="2060b3uf5szqe" />
          </>;
      case 'manipulation-resistance':
        return <>
            <ManipulationResistancePage data-id="element-30" data-mp="254lc3w28jnfw" />
            <FinalCTA data-id="element-31" data-mp="253k1fsp4t2yp" />
          </>;
      case 'emotional-regulation':
        return <>
            <EmotionalRegulationPage data-id="element-32" data-mp="29x4qgv8qymlr" />
            <FinalCTA data-id="element-33" data-mp="2ev6hc2cezq7s" />
          </>;
      case 'social-cooperation':
        return <>
            <SocialCooperationPage data-id="element-34" data-mp="2jthqeauvxwoy" />
            <FinalCTA data-id="element-35" data-mp="2jsg5zfrzbxuk" />
          </>;
      case 'self-direction':
        return <>
            <SelfDirectionPage data-id="element-36" data-mp="2nwe3jm1np0li" />
            <FinalCTA data-id="element-37" data-mp="2supi2a2wbza2" />
          </>;
      case 'leadership-responsibility':
        return <>
            <LeadershipResponsibilityPage data-id="element-38" data-mp="ti3jdqw0aum2" />
            <FinalCTA data-id="element-39" data-mp="tjek1hu5nm8y" />
          </>;
      case 'individual-level':
        return <>
            <IndividualLevelPage data-id="element-40" data-mp="yir5pz9ain9y" />
            <FinalCTA data-id="element-41" data-mp="21ras67b0o96l" />
          </>;
      case 'organizational-level':
        return <>
            <OrganizationalLevelPage data-id="element-42" data-mp="1wt96rfq4bxry" />
            <FinalCTA data-id="element-43" data-mp="1wubwhkbpfu6a" />
          </>;
      case 'municipal-scale':
        return <>
            <MunicipalScalePage data-id="element-44" data-mp="2aq5u37712x43" />
            <FinalCTA data-id="element-45" data-mp="25tfesm31s5jq" />
          </>;
      case 'national-scale':
        return <>
            <NationalScalePage data-id="element-46" data-mp="2kpwol8vl9c46" />
            <FinalCTA data-id="element-47" data-mp="2kp53irzmaws5" />
          </>;
      case 'home':
      default:
        return <>
            <HeroSection data-id="element-48" data-mp="2fr3c9js1fr5l" />
            <FramingBand data-id="element-49" data-mp="2tiql0j362s59" />
            <ProblemSection data-id="element-50" data-mp="2tj9urcinya87" />
            <PlatformOverview data-id="element-51" data-mp="2thgmjssejhy3" />
            <OperatingModel data-id="element-52" data-mp="2tkkvt4kq53vm" />
            <CapabilityDomains data-id="element-53" data-mp="2pgmwasrhlr21" />
            <HumanOpportunity data-id="element-54" data-mp="2pig2k6y6u99i" />
            <LifecycleArchitecture data-id="element-55" data-mp="2pjitgevigbpf" />
            <Solutions data-id="element-56" data-mp="33gedf2davnk9" />
            <ProductEcosystem data-id="element-57" data-mp="33hplheds3hh6" />
            <GlobalArchitecture data-id="element-58" data-mp="33etnjq1xkssq" />
            <LeadershipReadiness data-id="element-59" data-mp="2yicxgqb684d0" />
            <FAQ data-id="element-60" data-mp="2yj5zjdz6q5ot" />
            <FinalCTA data-id="element-61" data-mp="2yjnyiid8ey0f" />
          </>;
    }
  };
  return <div className="min-h-screen bg-surface-bg font-body text-ink-dark selection:bg-teal selection:text-white" data-id="element-62" data-mp="3i4o90y9ilrqm">
      <Navigation data-id="element-63" data-mp="3n1ephmp8epck" />
      <main data-id="element-64" data-mp="3n1y5uyz8h5oh">{renderPage()}</main>
      <Footer data-id="element-65" data-mp="385gtq5j7zn0v" />
    </div>;
}